export const TEST_DRIVE_ADDRESS_AU = "123 Main st, Sydney, NSW, AU, 2500"
export const TEST_DRIVE_ADDRESS_MX = "Av. Reforma 123, Ciudad de México, CDMX, MX, 06600"
/** @deprecated alias — equals AU; keep if callers still import TEST_DRIVE_ADDRESS */
export const TEST_DRIVE_ADDRESS = TEST_DRIVE_ADDRESS_AU

export const ADDRESS_BY_COUNTRY = {
  AU: "123 Main st, Sydney, NSW, AU, 2500",
  US: "123 Main St, Austin, TX, US, 78701",
  MX: "Av. Reforma 123, Ciudad de México, CDMX, MX, 06600",
  GB: "123 High Street, London, England, GB, SW1A 1AA",
  CA: "123 Main Street, Toronto, ON, CA, M5V 2T6",
  AG: "1 Old Parham Road, St. John's, AG",
  BS: "1 Bay Street, Nassau, NP, BS",
  BB: "1 Broad Street, Bridgetown, BB",
  BZ: "1 Regent Street, Belize City, BZ",
  GD: "1 Young Street, St. George's, GD",
  DM: "1 Kennedy Avenue, Roseau, DM",
  VC: "1 Bay Street, Kingstown, VC",
  KN: "1 Cayon Street, Basseterre, KN",
  LC: "1 Bridge Street, Castries, LC",
  TT: "1 Independence Square, Port of Spain, TT",
  JM: "1 Harbour Street, Kingston, JM",
  GT: "123 Avenida Reforma, Guatemala City, GT, 01009",
  HN: "123 Boulevard Morazán, Tegucigalpa, HN",
  CR: "123 Avenida Central, San José, CR, 10101",
  NI: "123 Avenida Bolívar, Managua, NI",
  PA: "123 Avenida Balboa, Panama City, PA",
  SV: "123 Avenida Jerusalén, San Salvador, SV",
  DO: "123 Avenida Winston Churchill, Santo Domingo, DO, 10127",
  CU: "123 Calle 23, Havana, CU, 10400",
  PR: "123 Avenida Ponce de León, San Juan, PR, 00907",
  AR: "123 Avenida Corrientes, Buenos Aires, AR, C1043",
  BO: "123 Avenida Arce, La Paz, BO",
  VE: "123 Avenida Francisco de Miranda, Caracas, VE, 1060",
  CO: "123 Carrera 7, Bogotá, CO, 110111",
  PY: "123 Avenida Mariscal López, Asunción, PY",
  PE: "123 Avenida Arequipa, Lima, PE, 15046",
  UY: "123 Avenida 18 de Julio, Montevideo, UY, 11200",
  CL: "123 Avenida Providencia, Santiago, CL, 7500000",
  EC: "123 Avenida Amazonas, Quito, EC, 170135",
  IE: "1 O'Connell Street, Dublin, IE, D01",
  MT: "1 Republic Street, Valletta, MT, VLT 1111",
  ES: "123 Calle Mayor, Madrid, ES, 28013",
  BW: "1 Independence Avenue, Gaborone, BW",
  BI: "1 Avenue de l'Uprona, Bujumbura, BI",
  GM: "1 Kairaba Avenue, Banjul, GM",
  GH: "1 Independence Avenue, Accra, GH",
  ZM: "1 Cairo Road, Lusaka, ZM",
  ZW: "1 Samora Machel Avenue, Harare, ZW",
  CM: "1 Boulevard du 20 Mai, Yaoundé, CM",
  KE: "1 Kenyatta Avenue, Nairobi, KE",
  LS: "1 Kingsway Road, Maseru, LS",
  LR: "1 Broad Street, Monrovia, LR",
  MW: "1 Victoria Avenue, Blantyre, MW",
  MU: "1 Sir William Newton Street, Port Louis, MU",
  NA: "1 Independence Avenue, Windhoek, NA",
  NG: "1 Shehu Shagari Way, Abuja, NG",
  RW: "1 KN 4 Avenue, Kigali, RW",
  SC: "1 Independence Avenue, Victoria, SC",
  SL: "1 Siaka Stevens Street, Freetown, SL",
  SD: "1 Nile Street, Khartoum, SD",
  TZ: "1 Samora Avenue, Dar es Salaam, TZ",
  UG: "1 Kampala Road, Kampala, UG",
  SZ: "1 Gwamile Street, Mbabane, SZ",
  ZA: "1 Church Square, Pretoria, GP, ZA, 0002",
  SS: "1 Ministries Road, Juba, SS",
  GQ: "123 Avenida de la Independencia, Malabo, GQ",
  IN: "1 Connaught Place, New Delhi, Delhi, IN, 110001",
  PK: "1 Jinnah Avenue, Islamabad, PK, 44000",
  SG: "1 Raffles Place, Singapore, SG, 048616",
  PH: "1 Ayala Avenue, Makati, Metro Manila, PH, 1226",
  VU: "1 Kumul Highway, Port Vila, VU",
  KI: "1 Bairiki Road, Bairiki, Tarawa, KI",
  MH: "1 Lagoon Road, Majuro, MH, 96960",
  FM: "1 Kolonia Road, Kolonia, Pohnpei, FM, 96941",
  NR: "1 Government Offices, Yaren, NR",
  NZ: "1 Lambton Quay, Wellington, NZ, 6011",
  PW: "1 Main Street, Koror, PW, 96940",
  PG: "1 Waigani Drive, Port Moresby, PG",
  WS: "1 Beach Road, Apia, WS",
  SB: "1 Mendana Avenue, Honiara, SB",
  TO: "1 Taufa'ahau Road, Nuku'alofa, TO",
  TV: "1 Vaiaku Road, Funafuti, TV",
  FJ: "1 Victoria Parade, Suva, FJ",
}

export function testDriveAddressForCountry(country, market) {
  if (typeof country === "string" && ADDRESS_BY_COUNTRY[country]) {
    return ADDRESS_BY_COUNTRY[country]
  }
  if (market === "es") return TEST_DRIVE_ADDRESS_MX
  return TEST_DRIVE_ADDRESS_AU
}
